const labels: { [key: string]: any } = {
  'unavailable.data': 'Dati al momento non disponibili',
  'reports.view.all.match.votes': 'Vedi tutti i voti',
  'legend.legend': 'Legenda',
  'legend.ballot': 'Ballottaggio',
  'example.label': 'Example label',
  'header.block.turnout': 'Affluenza',
  'header.block.equal.to': 'pari al',
  'header.block.equal.to.zero': 'pari allo',
  'header.block.equal.to.capitalized': 'Pari al',
  'header.block.equal.to.zero.capitalized': 'Pari allo',
  'header.block.sections.on': 'sezioni su',
  'header.block.of.all': 'del totale',
  'header.block.data.source': 'Fonte dati',
  'header.block.data.ministry': "Ministero dell'Interno",
  'header.block.data.definitive': 'Dato definitivo',
  'header.block.data.temporary': 'Dato provvisorio',
  // BACK BUTTON
  'go.back': 'Indietro',
  // LAST UPDATE
  'lastUpdate.last.update': 'Ultimo aggiornamento',
  // DATA SOURCE
  'dataSource.data.source': 'Fonte dati',
  // TITLES AND LABELS
  'titles-labels.regionalElectionsIn': 'Elezioni regionali in',
  'titles-labels.municipalElectionsIn': 'Elezioni comunali a',
  'titles-labels.results': 'i risultati',
  'titles-labels.percentageTurnout': 'Affluenza',
  'titles-labels.scrutinizedPollingStations': 'Sezioni scrutinate',
  // 'titles-labels.ballot': 'Ballottaggio',
  // 'titles-labels.firstRound': 'Primo turno',
  'titles-labels.on': 'su',
  'titles-labels.hour': 'ore',
  'titles-labels.legend': 'Legenda:',
  'titles-labels.elected': 'Eletto',
  // PARTIES RANKING
  'parties.ranking.th.logo': 'Partiti',
  'parties.ranking.th.name': 'Candidato/a',
  'parties.ranking.th.name.european': 'Liste/Gruppi',
  'parties.ranking.th.votes': 'Tot voti',
  'parties.ranking.th.percentage': '%',
  'parties.ranking.th.seats': 'Seggi',
  // SEARCH INPUT
  'search-input.loading': 'Caricamento...',
  'search-input.search.your.municipality': 'Cerca il tuo comune...',
  'search-input.label.your.municipality': 'Comune',
  'search-input.no.matches.found': `Nessuna corrispondenza trovata`,
  'search-input.cancel': `Annulla`,
  // COMBO BOX
  'combo-box.placeholder.region': 'Regione',
};

export default labels;
